module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "intro",
    staticClass: "intro slide-loadable",
    class: {
      'loaded': _vm.imageLoaded
    },
    style: ({
      filter: 'grayscale(' + _vm.introFade + '%)',
      backgroundImage: 'url(' + _vm.photoSource + ')'
    }),
    attrs: {
      "id": "site-intro",
      "role": "presentation"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2378218c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteIntro.vue
// module id = 117
// module chunks = 2